<template>
  <section id="sac-redirect">
    <div class="loading-container">
      <b-loading :active="isLoading" :is-full-page="false"></b-loading>
      <div v-if="isLoading" class="loading-message">
        <p>Authenticating with SAC...</p>
      </div>
      <div v-if="errorMessage" class="error-message">
        <b-message type="is-danger" has-icon>
          {{ errorMessage }}
        </b-message>
        <b-button type="is-primary" @click="redirectToLogin">
          Go to Login
        </b-button>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from "vuex";
import sacService from "@/services/sac";

export default {
  name: "SACRedirect",

  data() {
    return {
      isLoading: true,
      errorMessage: null,
    };
  },

  methods: {
    ...mapActions(["updateTeacherProfile"]),

    redirectToLogin() {
      this.$router.replace({ name: "login" });
    },

    async authenticateWithTempToken() {
      try {
        // Get query parameters
        const tempToken = this.$route.query.TempToken;
        const uid = this.$route.query.uid;

        // Validate parameters
        if (!tempToken || !uid) {
          this.errorMessage =
            "Missing authentication parameters. Please use the link provided by SAC.";
          this.isLoading = false;
          return;
        }

        // Call the loginWithTempToken method
        const result = await sacService.loginWithTempToken(tempToken, uid);

        if (result && result.token) {
          // Save teacher profile to store
          this.updateTeacherProfile({
            firstName: result.firstName,
            lastName: result.lastName,
            teacherId: result.teacherId,
          });

          // Show success message
          this.$buefy.toast.open({
            message: `Welcome back, ${result.firstName} ${result.lastName}!`,
            type: "is-success",
          });

          // Redirect to teacher home page
          this.$router.replace({ name: "TeacherHome" });
        } else {
          throw new Error("Authentication failed - no token received");
        }
      } catch (error) {
        console.error("SAC authentication error:", error);
        
        // Check if it's a token expiration error
        if (error.message && error.message.includes("expire")) {
          this.errorMessage =
            "Your authentication link has expired (5 minutes). Please log in to SAC again and use the new link.";
        } else {
          this.errorMessage =
            error.message || "Authentication failed. Please try again or use the regular login.";
        }
        
        this.isLoading = false;
      }
    },
  },

  async mounted() {
    // Start authentication process
    await this.authenticateWithTempToken();
  },
};
</script>

<style scoped>
#sac-redirect {
  background-color: white;
  width: 480px;
  min-height: 320px;
  padding: 2rem;
  margin-top: 5rem;
  margin-bottom: 10rem;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.loading-container {
  min-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.loading-message {
  text-align: center;
  margin-top: 2rem;
}

.loading-message p {
  font-size: 1.1rem;
  color: #4a4a4a;
}

.error-message {
  width: 100%;
  text-align: center;
}

.error-message .message {
  margin-bottom: 1rem;
}
</style>

